<script lang="ts" setup>
import type { PartName } from '@autobid/ui/composables/car/useDetailsPart'
import type { DetailsCarPart } from '@autobid/ui/types/components/CarDetails'
import { useDetailsPart } from '@autobid/ui/composables/car/useDetailsPart'

interface Props {
  partName: PartName
  part?: DetailsCarPart
}

const props = defineProps<Props>()
const { shouldBeRendered, list, freeText, labels } = useDetailsPart(
  props.partName,
  props.part,
)
</script>

<template>
  <div v-if="shouldBeRendered" class="col-span-12">
    <SectionsDetailsElementsSection class="pb-2">
      <template #heading>
        {{ labels.title }}
      </template>

      <template #content>
        <div class="grid grid-cols-12 gap-2.5">
          <div v-if="part?.table" class="col-span-12">
            <SectionsDetailsElementsTable
              :table="part.table"
              class="!font-semibold !text-primary lg:mt-1.5"
            />
          </div>

          <div v-if="part?.images?.length" class="col-span-12 mb-1">
            <SectionsDetailsElementsPartImageTable
              :title="labels.photos"
              :images="part.images"
            />
          </div>

          <div v-if="list?.length" class="col-span-12">
            <p class="mb-1 font-semibold">
              {{ labels.list }}:
            </p>
            <p>{{ list }}</p>
          </div>

          <SectionsDetailsElementsFreeText
            v-if="freeText?.length"
            class="col-span-12"
            :has-border="list?.length > 0"
            :free-text="freeText"
          />
        </div>
      </template>
    </SectionsDetailsElementsSection>
  </div>
</template>
